import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import styles from "./Calendar.module.css";
import AxiosInstance, { TokenService } from "../../../services/Api";
import { useNavigate } from "react-router-dom";
const CalendarList = () => {
  const navigate = useNavigate();
  const user = TokenService.getUser();
  const client_id = user?.client_data[0].client_id || "";
  const localizer = momentLocalizer(moment);
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState("month"); // ✅ ADD THIS
  const [event, setEvent] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [datas, setDatas] = useState();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const events = event
    .map((item) => {
      if (
        !item.start_date ||
        !item.end_date ||
        !item.start_time ||
        !item.end_time
      ) {
        return null;
      }
      // ✅ Safe date-time creation (prevents timezone bugs)
      const start = moment(
        `${item.start_date} ${item.start_time}`,
        "YYYY-MM-DD HH:mm",
      ).toDate();

      const end = moment(
        `${item.end_date} ${item.end_time}`,
        "YYYY-MM-DD HH:mm",
      ).toDate();

      // ✅ Ensure end > start
      if (end <= start) {
        end.setMinutes(start.getMinutes() + 30);
      }
      return {
        id: item.id,
        title: item.event_subject,
        description: item.event_description,
        venue: item.event_venue,
        start,
        end,
        allDay: false,
      };
    })
    .filter(Boolean);
  const handleNavigate = (newDate) => {
    setDate(newDate);
  };
  const handleEventClick = async (event) => {
    const eventId = event.id;   // ✅ get id directly
  setSelectedEvent(eventId);
    try {
      setLoading(true);
      const response = await AxiosInstance.get(
        `school/viewEvent/${eventId}`,
      );
      if (response.data.status) {
        const apiData = response.data.data;
        setDatas(apiData);
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (selectedEvent) {
  //     const fetchData = async () => {
  //       try {
  //         setLoading(true);
  //         const response = await AxiosInstance.get(`school/viewEvent/${selectedEvent}`);
  //         if (response.data.status) {
  //           const apiData = response.data.data;
  //           setDatas(apiData);

  //         } else {
  //           throw new Error(response.data.message);
  //         }
  //       } catch (err) {
  //         console.log(err);

  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchData();
  //   }

  // }, [selectedEvent]);

  const handleEedit = () => {
    navigate(`/user/calender/create`, {
      state: {
        DATAS: datas[0].id,
      },
    });
  };
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await AxiosInstance.post("/school/Eventlist", {
          client_id: client_id,
        });
        if (response.data.status) {
          setEvent(response.data.data);
        } else {
          throw new Error(response.data.message);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);
  return (
    <div className={styles.wrapper}>
      {/* Toolbar */}
      <div className={styles.toolbar}>
        <div className={styles.leftControls}>
          <button
            className="fa-solid fa-angles-left"
            onClick={() =>
              handleNavigate(moment(date).subtract(1, "year").toDate())
            }
          />
          <button
            className="fa-solid fa-angles-right"
            onClick={() => handleNavigate(moment(date).add(1, "year").toDate())}
          />

          <button
            className="fa-solid fa-angle-left"
            onClick={() =>
              handleNavigate(moment(date).subtract(1, "month").toDate())
            }
          />
          <button
            className="fa-solid fa-angle-right"
            onClick={() =>
              handleNavigate(moment(date).add(1, "month").toDate())
            }
          />

          <button onClick={() => handleNavigate(new Date())}>today</button>
        </div>

        <div className={styles.monthTitle}>
          {moment(date).format("MMMM YYYY").toUpperCase()}
        </div>

        {/* ✅ VIEW CONTROLS */}
        <div className={styles.viewControls}>
          <button
            className={view === "month" ? styles.active : ""}
            onClick={() => setView("month")}
          >
            month
          </button>
          <button
            className={view === "week" ? styles.active : ""}
            onClick={() => setView("week")}
          >
            week
          </button>
          <button
            className={view === "day" ? styles.active : ""}
            onClick={() => setView("day")}
          >
            day
          </button>
        </div>
      </div>

      {/* Calendar */}
      <Calendar
        localizer={localizer}
        date={date}
        view={view}
        onView={setView}
        onNavigate={handleNavigate}
        events={events}
        onSelectEvent={handleEventClick}
        toolbar={false}
        startAccessor="start"
        endAccessor="end"
        className={styles.calendar}
      />
      {datas && (
        <div
          className={styles.modalOverlay}
          onClick={() => setSelectedEvent(null)}
        >
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <h2 className={styles.modalTitle}>Event Detail!</h2>
            <p>
              <strong>Description :</strong> {datas[0].event_description}
            </p>
            <p>
              <strong>Venue :</strong> {datas[0].event_venue}
            </p>
            <p>
              <strong>Time :</strong>{" "}
              {moment(datas[0].start_time, "HH:mm:ss").format("hh:mm A")} -
              {moment(datas[0].end_time, "HH:mm:ss").format("hh:mm A")}
            </p>

            <div className={styles.modalActions}>
              <button
                className={styles.cancelBtn}
                onClick={() => setDatas(null)}
              >
                Cancel
              </button>

              {user?.role?.id === 5 && (
                <button onClick={handleEedit} className={styles.editBtn}>
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarList;
